<div #calendarParentDiv id="calendarParentDiv" class="container-fluid col-12 calendarParent background-white" *ngIf="isHidden()">
  <div class="container calendar-day-box col-xl-7 col-lg-9 col-md-11 col-sm-12 col-12" *ngIf="!editOrderAddingAnotherItem && pastOrderAgain">
    <div class="navigationArrows">
      <span class="navigationInner" (click)="previousDate()" *ngIf="startPoint">
        <img width="15" src="assets/images/calendar-arrow-right.svg" style="transform: rotate(180deg);">
      </span>
    </div>

    <div class="calendarCenter">
      <h1 class="calendar-heading">CHOOSE A DELIVERY DATE</h1>
      <div class="dateRow">
        <div *ngFor="let day of (days ? days.slice(startPoint, endPoint): []); let i = index"
            class="calendar-day animated"
            [class.flipInX] = "true"
            [class.is-selected]="day.isSelected"
            [class.is-saturday]="day.dayName === 'Sunday' || day.isHoliday || day.disable"
            (click)="selectedDateClick(day)"
            [id]="day.arrIndex"
            [ngStyle]="{'width': 100/showNoDays + '%'}" >
          <h3 class="dayName">{{day.dayName}}</h3>
          <h2 class="monthName">{{day.monthName}}</h2>
          <p class="dayNumber">{{day.dayNumber}}</p>
        </div>
      </div>
    </div>

    <div class="navigationArrows">
      <span class="navigationInner" (click)="nextDate()" *ngIf="endPoint !== 30">
        <img width="15" src="assets/images/calendar-arrow-right.svg">
      </span>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/modules/shared/calendar/calendar.component.html